import { render, staticRenderFns } from "./FreeHealthCheckDataTable.vue?vue&type=template&id=2d6b0476&scoped=true"
import script from "./FreeHealthCheckDataTable.vue?vue&type=script&lang=js"
export * from "./FreeHealthCheckDataTable.vue?vue&type=script&lang=js"
import style0 from "./FreeHealthCheckDataTable.vue?vue&type=style&index=0&id=2d6b0476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6b0476",
  null
  
)

export default component.exports